export function getHeaderCaseInsensitive(headers, name) {
  const key = Object.keys(headers).find(key => key.toLowerCase() === name.toLowerCase());
  return key ? headers[key] ?? '' : '';
}